import React, { useEffect, useRef, useState } from "react";
import { Bars3Icon } from "@heroicons/react/24/outline";
import logo from "../../assets/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaRegCopy } from "react-icons/fa";
import { TbLogout } from "react-icons/tb";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { Transition } from "@headlessui/react";
import { UserCircleIcon } from "@heroicons/react/20/solid";
import toast, { Toaster } from "react-hot-toast";
import { IoKeyOutline } from "react-icons/io5";
import ModalComponent from "../modalComponent/ModalComponent";
import { FiClock, FiChevronDown, FiChevronRight, FiShoppingBag, FiPlus, FiList } from "react-icons/fi";
import Button from "../button/Button";
import { useSelector, useDispatch } from "react-redux";
import { handleLogIn } from "./navbarSlice";
import { removeUser } from "../login/userSlice";
import { WEB_URL } from "../../constant/Constant";
import RegisterService from "../../services/RegisterService";
import { createPortal } from "react-dom";
import { closeModal, openModal, selectModalContentId } from "../modalComponent/modalSlice";
import LoaderButton from "../button/LoaderButton";

export default function Navbar() {
  const [seconds, setSeconds] = useState(30);
  const [intervalId, setIntervalId] = useState(null);
  const [count, setCount] = useState(0);
  const [verifyBtnDisabled, setVerifyBtnDisabled] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isResetButton, setIsResetButton] = useState(false);
  const [resendBtnDisabled, setResendBtnDisabled] = useState(false);
  const [dealerMessage, setDealerMessage] = useState("");
  const modalContentId = useSelector(selectModalContentId);
  const isLoggedIn = localStorage.getItem("loggedIn");
  const dispatch = useDispatch();
  const [showNavmenu, setShowNavmenu] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const navbarMenuRef = useRef(null);
  const navbarButtonRef = useRef(null);
  const navigate = useNavigate();
  const referralCode = localStorage.getItem("reffralCode") || "";
  const userRoleId = localStorage.getItem("roleId") || "";
  const location = useLocation();
  const route = location.pathname.split("/")[1];
  const [isOpen, setIsOpen] = useState(false);
  const adminSectionRef = useRef(null);

  const validModalIds = [
    "please login first",
    "user not verified",
    "user not acknowledge signup contract dealer",
    "Acknowledgement Pending dealer",
    "Unauthorized access",
    "Forbidden: You do not have permission",
    "Network error, please try again later",
    "Something went wrong, please try again later",
  ];

  useEffect(() => {
    if (count === 2) {
      // Clear any existing interval
      if (intervalId) {
        clearInterval(intervalId);
      }
      // Start new timer
      setSeconds(30); // Ensure seconds is reset
      const interval = setInterval(() => {
        setSeconds((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            setIntervalId(null);
            setCount(0); // Reset count when timer ends
            setIsResetButton(true); // Show Resend/Check Status buttons
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      setIntervalId(interval);
      return () => clearInterval(interval);
    }
  }, [count]);

  const toggleMenu = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const formattedTime = `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;

  const MenuListItems = [
    {
      id: 1,
      title: "Home",
      links: "/",
    },
    // Conditionally include the Dashboard item based on roleId
    ...(userRoleId === "ROLE_DEALER" ||
    userRoleId === "ROLE_COMPANY_DEALER"
      ? [
          {
            id: 2,
            title: "Dashboard",
            links: "/dashboard",
          },
        ]
      : []),
    { id: 4, title: "About Us", links: "/about-us" },
    { id: 6, title: "FAQ's", links: "/faq" },
    { id: 7, title: "IoT Devices", links: "/iot-devices" },
    { id: 8, title: "Blogs", links: "/blogs" },
  ];

  const [RoleId, setRoleId] = useState(localStorage.getItem("roleId") || "");

  useEffect(() => {
    const handleStorageChange = () => {
      setRoleId(localStorage.getItem("roleId") || "");
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleFunc = () => {
    dispatch(handleLogIn());
  };

  useEffect(() => {
    if (localStorage.getItem("userId")) {
      dispatch(handleLogIn());
    }
  }, []);

  const handleAddManager = async () => {
    const isUserVerified = Number(localStorage.getItem("isVerified"));
    const userId = localStorage.getItem("userId");
    const loggedIn = localStorage.getItem("loggedIn");

    if (!loggedIn) {
      dispatch(openModal("please login first"));
      return;
    }

    try {
      setLoader(true);
      const response = await RegisterService.signupContractAcknowledgementStatus(userId);
      console.log("Add Manager response:", response);
      if (response.status === 200) {
        const isAcknowledge = response.data;
        localStorage.setItem("isAcknowledge", isAcknowledge);
        if (isAcknowledge == 0) {
          setLoader(false);
          setIsResetButton(true);
          setCount(0); // Reset count to ensure timer can restart
          dispatch(openModal("user not acknowledge signup contract dealer"));
          return;
        }
        if (!isUserVerified) {
          setLoader(false);
          dispatch(openModal("user not verified"));
          return;
        }
        setLoader(false);
        navigate("/addManager");
      }
    } catch (error) {
      setLoader(false);
      console.error("Add Manager error:", error);
      dispatch(
        openModal(
          error.message === "Network Error"
            ? "Network error, please try again later"
            : error.response?.status === 401
            ? "Unauthorized access"
            : error.response?.status === 403
            ? "Forbidden: You do not have permission"
            : "Something went wrong, please try again later"
        )
      );
    }
  };

  const handleAddAgent = async () => {
    const isUserVerified = Number(localStorage.getItem("isVerified"));
    const userId = localStorage.getItem("userId");
    const loggedIn = localStorage.getItem("loggedIn");

    if (!loggedIn) {
      dispatch(openModal("please login first"));
      return;
    }

    try {
      setLoader(true);
      const response = await RegisterService.signupContractAcknowledgementStatus(userId);
      console.log("Add Agent response:", response);
      if (response.status === 200) {
        const isAcknowledge = response.data;
        localStorage.setItem("isAcknowledge", isAcknowledge);
        if (isAcknowledge == 0) {
          setLoader(false);
          setIsResetButton(true);
          setCount(0); // Reset count to ensure timer can restart
          dispatch(openModal("user not acknowledge signup contract dealer"));
          return;
        }
        if (!isUserVerified) {
          setLoader(false);
          dispatch(openModal("user not verified"));
          return;
        }
        setLoader(false);
        navigate("/addAgent");
      }
    } catch (error) {
      setLoader(false);
      console.error("Add Agent error:", error);
      dispatch(
        openModal(
          error.message === "Network Error"
            ? "Network error, please try again later"
            : error.response?.status === 401
            ? "Unauthorized access"
            : error.response?.status === 403
            ? "Forbidden: You do not have permission"
            : "Something went wrong, please try again later"
        )
      );
    }
  };

  const handleResend = () => {
    if (resendBtnDisabled) return;
    setResendBtnDisabled(true);
    const userId = localStorage.getItem("userId");
    console.log("Resend button clicked, userId:", userId);
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
    setCount(0); // Reset count to allow timer to restart
    setSeconds(30); // Reset seconds
    RegisterService.resendDealerSignupContractLink(userId)
      .then((response) => {
        console.log("Resend API response:", response);
        setResendBtnDisabled(false);
        setIsResetButton(false);
        setDealerMessage("");
        if (response.data.status === "success") {
          setCount(2); // Trigger timer
          dispatch(openModal("Acknowledgement Pending dealer"));
          let totalTime = 0;
          const interval = setInterval(() => {
            RegisterService.signupContractAcknowledgementStatus(userId)
              .then((response1) => {
                console.log("Acknowledgement status check:", response1);
                setDealerMessage("");
                if (response1.status === 200) {
                  if (response1.data === 0) {
                    totalTime += 10;
                    if (totalTime >= 30) {
                      clearInterval(interval);
                      setIntervalId(null);
                      localStorage.setItem("isAcknowledge", response1.data);
                      setIsResetButton(true);
                      setCount(0); // Reset count when acknowledgment check ends
                    }
                  } else if (response1.data === 1) {
                    localStorage.setItem("isAcknowledge", response1.data);
                    dispatch(closeModal());
                    clearInterval(interval);
                    setIntervalId(null);
                    setIsResetButton(false);
                    setCount(0); // Reset count when acknowledgment is confirmed
                  }
                }
              })
              .catch((error) => {
                console.error("Acknowledgement status check error:", error);
                setResendBtnDisabled(false);
                setLoader(false);
                setDealerMessage(
                  error.message === "Network Error"
                    ? "Network error, please try again later"
                    : error.response?.status === 401
                    ? "Unauthorized access"
                    : error.response?.status === 403
                    ? "Forbidden: You do not have permission"
                    : "Something went wrong, please try again later"
                );
                clearInterval(interval);
                setIntervalId(null);
                setCount(0); // Reset count on error
              });
          }, 10000);
          setIntervalId(interval);
        } else {
          setDealerMessage("Failed to resend acknowledgment link.");
        }
      })
      .catch((error) => {
        console.error("Resend API error:", error);
        setResendBtnDisabled(false);
        setLoader(false);
        setDealerMessage(
          error.message === "Network Error"
            ? "Network error, please try again later"
            : error.response?.status === 401
            ? "Unauthorized access"
            : error.response?.status === 403
            ? "Forbidden: You do not have permission"
            : error.response?.data?.failedReason || "Something went wrong, please try again later"
        );
      });
  };

  const checkVerificationStatus = () => {
    setLoader(true);
    setVerifyBtnDisabled(true);
    const userId = localStorage.getItem("userId");
    RegisterService.signupContractAcknowledgementStatus(userId)
      .then((response1) => {
        console.log("Check verification status response:", response1);
        setLoader(false);
        setVerifyBtnDisabled(false);
        if (response1.status === 200) {
          if (response1.data === 0) {
            setDealerMessage("Signup Agreement is not acknowledged yet. Please check email.");
          } else if (response1.data === 1) {
            setDealerMessage("");
            localStorage.setItem("isAcknowledge", response1.data);
            dispatch(closeModal());
            setIsResetButton(false);
            setCount(0); // Reset count after verification
          }
        }
      })
      .catch((error) => {
        console.error("Check verification status error:", error);
        setLoader(false);
        setVerifyBtnDisabled(false);
        setDealerMessage(
          error.message === "Network Error"
            ? "Network error, please try again later"
            : error.response?.status === 401
            ? "Unauthorized access"
            : error.response?.status === 403
            ? "Forbidden: You do not have permission"
            : "Something went wrong, please try again later"
        );
      });
  };

  const handleSignOut = () => {
    localStorage.clear();
    dispatch(removeUser());
    navigate("/");
  };

  const isReferralCodeValid = referralCode !== null && referralCode !== "undefined" && referralCode !== "";

  const MenuTray = ({ customClass }) => (
    <ul ref={navbarMenuRef} className={customClass}>
      <li className="truncate px-0 lg:px-5 py-2 mb-2 pointer-events-none cursor-none font-medium">
        {localStorage.getItem("emailId")}
      </li>
      <li className="truncate px-0 lg:px-5 py-2 mb-2 pointer-events-none cursor-none font-medium">
        {localStorage.getItem("name")}
      </li>
      <hr className="py-1 hidden lg:block" />
      {isReferralCodeValid && (
        <li onClick={handleReferralCodeCopy} className="flex flex-col px-0 lg:px-5 py-2 mb-2 cursor-pointer font-medium">
          <div className="w-full flex justify-between items-center">
            <div className="overflow-x-hidden">
              <span className="text-sm font-medium">Referral Code:</span>
              <p className="truncate font-semibold">{referralCode}</p>
            </div>
            <div>
              <FaRegCopy className="text-xl ml-3" />
            </div>
          </div>
        </li>
      )}
      {isReferralCodeValid && (
        <li onClick={handleReferralUrlCopy} className="flex flex-col px-0 lg:px-5 py-2 mb-2 cursor-pointer font-medium">
          <div className="w-full flex justify-between items-center">
            <div className="overflow-x-hidden">
              <span className="text-sm font-medium">Referral URL:</span>
              <p className="truncate font-semibold text-sm">{WEB_URL}{referralCode}</p>
            </div>
            <div>
              <FaRegCopy className="text-xl ml-3" />
            </div>
          </div>
        </li>
      )}
      <li onClick={() => navigate("/changePassword")} className="flex justify-between items-center px-0 lg:px-5 py-2 mb-2 cursor-pointer font-medium">
        <p className="truncate">Change Password</p>
        <div>
          <IoKeyOutline className="text-2xl ml-3" />
        </div>
      </li>
      <li onClick={() => navigate("/myorder")} className="flex justify-between items-center px-0 lg:px-5 py-2 mb-2 cursor-pointer font-medium">
        <p className="truncate">{userRoleId === "ROLE_DEALER" || userRoleId === "ROLE_MANAGER" || userRoleId === "ROLE_AGENT" || userRoleId === "ROLE_COMPANY_DEALER" ? "Customer Order Data" : "My Plans"}</p>
        <div>
          <FiShoppingBag className="text-2xl ml-3" />
        </div>
      </li>
      {(userRoleId === "ROLE_COMPANY_DEALER" || userRoleId === "ROLE_MANAGER") && (
        <div ref={adminSectionRef} className="admin-section w-full">
          <div onClick={toggleMenu} className="flex justify-between items-center px-0 lg:px-5 py-2 cursor-pointer font-semibold hover:bg-gray-100 rounded">
            <p className="truncate">Admin</p>
            <div>{isOpen ? <FiChevronDown className="text-2xl ml-3" /> : <FiChevronRight className="text-2xl ml-3" />}</div>
          </div>
          {isOpen && (
            <ul className="ml-4 space-y-2 mt-2">
              {userRoleId === "ROLE_COMPANY_DEALER" && (
                <li onClick={handleAddManager} className="flex justify-between items-center px-0 lg:px-5 py-2 cursor-pointer font-medium hover:bg-gray-100 rounded">
                  <p className="truncate">Add Manager</p>
                  <FiPlus className="text-2xl ml-3" />
                </li>
              )}
              {(userRoleId === "ROLE_COMPANY_DEALER" || userRoleId === "ROLE_MANAGER") && (
                <>
                  <li onClick={handleAddAgent} className="flex justify-between items-center px-0 lg:px-5 py-2 cursor-pointer font-medium hover:bg-gray-100 rounded">
                    <p className="truncate">Add Agent</p>
                    <FiPlus className="text-2xl ml-3" />
                  </li>
                  <li onClick={() => navigate("/userList")} className="flex justify-between items-center px-0 lg:px-5 py-2 cursor-pointer font-medium hover:bg-gray-100 rounded">
                    <p className="truncate">User List</p>
                    <FiList className="text-2xl ml-3" />
                  </li>
                </>
              )}
            </ul>
          )}
        </div>
      )}
      <hr className="py-1 hidden lg:block mb-2" />
      <li onClick={handleSignOut} className="w-full flex justify-between items-center px-0 lg:px-5 py-2 cursor-pointer font-medium">
        <p>Sign out</p>
        <div>
          <TbLogout className="text-2xl" />
        </div>
      </li>
    </ul>
  );

  const handleReferralCodeCopy = () => {
    navigator.clipboard
      .writeText(referralCode)
      .then(() => toast.success("Referral code copied successfully!", { style: { border: "1px solid #65D14E" } }))
      .catch(() => toast.error("Error copying referral code", { style: { border: "1px solid red" } }));
  };

  const handleReferralUrlCopy = () => {
    navigator.clipboard
      .writeText(WEB_URL + referralCode)
      .then(() => toast.success("Referral URL copied successfully!", { style: { border: "1px solid #65D14E" } }))
      .catch(() => toast.error("Error copying referral URL", { style: { border: "1px solid red" } }));
  };

  const handleCloseNavMenu = (event) => {
    if (
      showNavmenu &&
      navbarMenuRef.current &&
      navbarButtonRef.current &&
      !navbarMenuRef.current.contains(event.target) &&
      !navbarButtonRef.current.contains(event.target)
    ) {
      setShowNavmenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleCloseNavMenu);
    return () => document.removeEventListener("click", handleCloseNavMenu);
  }, [showNavmenu]);

  return (
    <header className="sticky top-0 z-20 shadow mb-6">
      <nav style={{ zIndex: 2 }} className="px-4 lg:px-6 relative bg-secondary">
        <div className="w-full grid grid-cols-2 lg:grid-cols-3 max-w-screen-xl mx-auto">
          <Link onClick={handleFunc} to="/" className="flex items-center">
            <img src={logo} className="mr-3 h-20 p-3" alt="GKT" />
          </Link>
          <ul className="hidden lg:flex justify-center items-center gap-14">
            {MenuListItems.map((item) => (
              <li className="block nav-link mb-5 lg:mb-0 font-medium" key={item.id}>
                <Link to={item.links} className={`${"/" + route === item.links ? "border-b-2 border-[#6ea8ad]" : ""} anchor whitespace-nowrap`}>
                  {item.title}
                </Link>
              </li>
            ))}
            {isLoggedIn && <MenuTray customClass="block lg:hidden" />}
          </ul>
          <div className="flex justify-end items-center cursor-pointer gap-1">
            {isLoggedIn ? (
              <div ref={navbarButtonRef} className="relative">
                {isUser ? (
                  <img
                    onClick={() => setShowNavmenu(!showNavmenu)}
                    className={`${showNavmenu ? "border-2 border-teal-600" : "border-none"} h-10 w-10 rounded-md`}
                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    alt=""
                  />
                ) : (
                  <UserCircleIcon
                    onClick={() => setShowNavmenu(!showNavmenu)}
                    className={`w-12 rounded-[100px] ${showNavmenu ? "border-2 border-teal-600" : "border-none"}`}
                  />
                )}
                {isLoggedIn && (
                  <Transition
                    show={showNavmenu}
                    enter="transition-all duration-300 transform translate-x-6"
                    enterFrom="opacity-0 transform translate-x-6"
                    enterTo="opacity-100 transform translate-x-0"
                    leave="transition-all duration-150"
                    leaveFrom="opacity-100 transform translate-x-0"
                    leaveTo="opacity-0 transform translate-x-6"
                  >
                    <div className="card menu-tray shadow-md hidden lg:block absolute right-0 top-14 p-2 w-64">
                      <MenuTray />
                    </div>
                  </Transition>
                )}
              </div>
            ) : (
              <>
                <Link to="/login">
                  <Button title="Log in" type="button" style="cta-two" />
                </Link>
                <Link to="/register">
                  <Button title="Get started" type="button" style="cta-one" />
                </Link>
              </>
            )}
            {!isLoggedIn && (
              <div
                style={{ width: "40px", height: "40px" }}
                className="lg:hidden cursor-pointer transition-all ease-in-out md:mr-2 rounded flex justify-center items-center border-teal-600 border hover:border-2"
                onClick={() => setShowNavmenu(!showNavmenu)}
              >
                {showNavmenu ? (
                  <XMarkIcon
                    width={32}
                    height={32}
                    className="flex items-center p-0 text-sm text-teal-600"
                  />
                ) : (
                  <Bars3Icon
                    width={32}
                    height={32}
                    className="flex items-center p-0 text-sm text-teal-600"
                    aria-controls="mobile-menu-2"
                    aria-expanded="false"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </nav>
      <Transition
        show={showNavmenu}
        enter="transition-all duration-300 transform -translate-y-6"
        enterFrom="opacity-0 transform -translate-y-6"
        enterTo="opacity-100 transform translate-y-0"
        leave="transition-all duration-150"
        leaveFrom="opacity-100 transform translate-y-0"
        leaveTo="opacity-0 transform -translate-y-6"
      >
        <div
          style={{ zIndex: 3 }}
          className="flex-col px-4 lg:px-6 py-2.5 border-b border-teal-600 bg-secondary absolute lg:relative justify-center items-start w-full lg:hidden flex lg:w-auto lg:order-1"
        >
          <ul className="flex flex-col justify-center items-start">
            {MenuListItems.map((item) => (
              <li className="block nav-link mb-5 font-medium" key={item.id}>
                <Link to={item.links}>{item.title}</Link>
              </li>
            ))}
          </ul>
          {isLoggedIn && <MenuTray customClass="w-full block lg:hidden" />}
        </div>
      </Transition>
      <Toaster position="top-center" reverseOrder={false} />
      {modalContentId && validModalIds.includes(modalContentId) && (
        createPortal(
          <div className="fixed inset-0 z-[9999]">
            <div
              className="fixed inset-0 bg-black/30"
              onClick={() => {
                dispatch(closeModal());
                setCount(0); // Reset count when modal is closed
              }}
            />
            <div className="relative z-[10000] flex items-center justify-center min-h-screen p-4">
              <div className="w-full max-w-md" onClick={(e) => e.stopPropagation()}>
                <ModalComponent
                  size="md"
                  type="pending"
                  position="center"
                  description=""
                  bottomLine={true}
                  title={
                    modalContentId === "Network error, please try again later"
                      ? "Network Error Occurred"
                      : modalContentId === "please login first"
                      ? "Verification Pending"
                      : modalContentId === "user not verified"
                      ? "Verification Pending"
                      : modalContentId === "user not acknowledge signup contract dealer"
                      ? "Acknowledgement Pending"
                      : modalContentId === "Acknowledgement Pending dealer"
                      ? "Acknowledgement Pending"
                      : modalContentId === "Unauthorized access"
                      ? "Unauthorized Access"
                      : modalContentId === "Forbidden: You do not have permission"
                      ? "Unauthorized Access"
                      : modalContentId === "Something went wrong, please try again later"
                      ? "Error"
                      : "Error"
                  }
                >
                  <div className="flex flex-col">
                    {modalContentId === "Network error, please try again later" ? (
                      <p>Network Error Occurred. Please try again later.</p>
                    ) : modalContentId === "please login first" ? (
                      <p>Please log in to continue.</p>
                    ) : modalContentId === "user not verified" ? (
                      <p>
                        A verification link has been sent to your registered email address. Please click on <span className="font-semibold">"Verify Email"</span> button to verify.
                      </p>
                    ) : modalContentId === "user not acknowledge signup contract dealer" ? (
                      <p>Please acknowledge the Signup Agreement first, then continue.</p>
                    ) : modalContentId === "Unauthorized access" ? (
                      <p>Unauthorized access. Please log in with appropriate credentials.</p>
                    ) : modalContentId === "Forbidden: You do not have permission" ? (
                      <p>You do not have permission to perform this action.</p>
                    ) : modalContentId === "Something went wrong, please try again later" ? (
                      <p>Something went wrong. Please try again later.</p>
                    ) : modalContentId === "Acknowledgement Pending dealer" ? (
                      <div className="w-100 d-flex flex-column justify-content-center align-items-center mt-3">
                        <h3 className="mb-3 text-center">
                          Please check your email for acknowledgement mail and click on "acknowledge" button to continue.
                        </h3>
                        <div className="flex flex-col items-center justify-center">
                          <FiClock className="text-[42px]" />
                          <h2 className="font-bold">{formattedTime}</h2>
                          <span className="info">*Acknowledgement status checking is in progress</span>
                        </div>
                      </div>
                    ) : (
                      <p>An unexpected error occurred. Please try again.</p>
                    )}
                    {isResetButton && (
                      <div className="flex justify-center gap-4 mt-4">
                        <LoaderButton
                          type="button"
                          title="Resend"
                          handleClick={handleResend}
                          style="rounded w-1/3 text-sm px-4 py-2 cta-one font-semibold text-center"
                          disabled={resendBtnDisabled}
                        />
                        <LoaderButton
                          type="button"
                          title="Check Status"
                          name="checkVerificationStatusDealer"
                          handleClick={checkVerificationStatus}
                          style="rounded w-1/3 text-sm px-4 py-2 cta-one font-semibold text-center"
                          disabled={verifyBtnDisabled}
                        />
                      </div>
                    )}
                    {dealerMessage && <p className="error-text">{dealerMessage}</p>}
                  </div>
                </ModalComponent>
              </div>
            </div>
          </div>,
          document.body
        )
      )}
    </header>
  );
}